// extracted by mini-css-extract-plugin
module.exports = {"container":"PendingPaymentCard_container__l4_8v","modalContainer":"PendingPaymentCard_modalContainer__b0gei"};